
import barba from '@barba/core';

export default class{

	constructor(){
        // this.tab_wrapper = '.js-tab'
        // this.tab_item = '.js-tab__item'
        // this.tab_pane = '.js-tab__pane'
        // this.active_class = 'c-tab__active'

        this.index_flow = '#js-index__philosophy'
        this.index_areas = '.js-index__area'
        // this.index_active = '#js-index__list .is-active'
        // this.active_class = 'is-active'
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init(){
        const philosophy = document.querySelector('#js-index__philosophy');
        if(philosophy) {
            const areas = document.querySelectorAll('.js-index__area');
            const options = {
                root: null,
                rootMargin: '-50% 0px',
                threshold: 0
            };
            const observer = new IntersectionObserver(doWhenIntersect, options);
            areas.forEach(area => {
                observer.observe(area);
            });
        }
        /**
         * 交差したときに呼びだす関数
         * @param entries
         */
        function doWhenIntersect(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    activateIndex(entry.target);
                }
            });
        }

        /**
         * @param element
         */
        function activateIndex(element) {
            const currentActiveIndex = document.querySelectorAll('.is-activeCircle');
            if(currentActiveIndex.length >= 4) {
                return false;
            }
            const newActiveArea = document.querySelector(`[data-area='${element.id}']`);
            const newActiveIndex = document.querySelector(`[data-circle='${element.id}']`);
            const newActiveDesc = document.querySelector(`[data-desc='${element.id}']`);
            
            if(newActiveArea) {
                newActiveArea.classList.add('is-activeArea');
            }
            if(newActiveIndex) {
                newActiveIndex.classList.add('is-activeCircle');
            }
            if(newActiveDesc) {
                newActiveDesc.classList.add('is-activeDesc');
            }
        }
    }
}